export default __webpack_public_path__ + "static/media/maifood-advantech-unit.4fa559bc.png";